module.exports = __webpack_public_path__ + "static/media/Nokia Asha 230 Green.a68df369.png";